import { Link } from "react-router-dom";
import { hotList } from "@/mocks/home";

const tagStyle: Record<string, string> = {
  更新: "bg-accent-100 text-accent-900",
  热: "bg-primary-100 text-primary-800",
  平: "bg-secondary-100 text-secondary-800",
};

export default function HotBoard() {
  return (
    <section id="hot" className="w-full bg-background-100 border-y border-background-200 scroll-mt-20">
      <div className="max-w-content mx-auto w-full px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <span className="text-xs md:text-sm font-medium text-primary-600 tracking-wide">
              TODAY / 今日热榜
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              此刻讨论最多的话题
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md">
            榜单按话题近 24 小时的讨论量排序，带「更新」标记表示补齐了新的后续进展。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-1">
          {hotList.map((item) => (
            <Link
              key={item.rank}
              to={`/topic/${item.topicId}`}
              className="group flex items-center gap-4 py-4 border-b border-background-200"
            >
              <span
                className={`w-8 shrink-0 text-center font-heading text-xl font-bold ${
                  item.rank <= 3 ? "text-primary-500" : "text-foreground-400"
                }`}
              >
                {String(item.rank).padStart(2, "0")}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </p>
                <div className="flex items-center gap-2 mt-1.5">
                  <span className="text-xs text-foreground-500">{item.category}</span>
                  <span className="text-xs text-foreground-300">·</span>
                  <span className="text-xs text-foreground-500">热度 {item.heat}</span>
                </div>
              </div>
              <span
                className={`shrink-0 px-2 py-0.5 rounded-md text-xs ${tagStyle[item.tag] ?? "bg-secondary-100 text-secondary-800"}`}
              >
                {item.tag}
              </span>
              <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
            </Link>
          ))}
        </div>

        <div className="mt-8">
          <Link
            to="/collections"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors"
          >
            查看完整榜单与全部合集
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}